






































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import CityPO from "@/store/entities/basedata/citypo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
@Component({
  components: { TreeSelect },
})
export default class CreateCity extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  citypo: CityPO = new CityPO();
  loading: boolean = false;
  created() {
    this.itemtree();
    this.citypo.isEnable = 1;
    this.citypo.parentId = 0;
  }
  create() {
    //console.log(this.list);
  }
  save() {
    (this.$refs.areaForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store.dispatch({
          type: "city/create",
          data: this.citypo,
        }).catch(() => {
          this.loading = false;
        });
        this.loading = false;
        (this.$refs.areaForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.areaForm as any).resetFields();
    this.$emit("input", false);
  }
  async itemtree() {
    await this.$store
      .dispatch("city/getCitySelectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  areaRule = {
    fullName: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    parentId: [
      {
        type: "number",
        require: true,
        message: this.L("FirstNodeCanNotEmpty"),
        trigger: "blur",
      },
    ],
    simpleSpelling: [{
      trigger: "blur",
    }],
  };
  data() {
    return {
      optionsMechanism: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
